import {
  IContactForm,
  IUploadedFile,
  IZendeskRequest,
} from 'models/zendesk.model'

import { READABLE_APP_NAMES, SUPPORT_EMAILS } from 'root-constants'

export const createZendeskRequest = ({
  appName,
  formData: { topic, request, name, email },
  uploadedFiles,
}: {
  appName: string
  formData: IContactForm
  uploadedFiles: IUploadedFile[]
}): IZendeskRequest => ({
  request: {
    subject: `${READABLE_APP_NAMES[appName]}: ${topic}`,
    recipient: SUPPORT_EMAILS[appName],
    comment: {
      body: request,
      uploads: uploadedFiles.map(({ token = '' }) => token),
    },
    requester: {
      name,
      email,
    },
  },
})
